import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const WorkflowRunsListPage = lazy(
  () => import('~/features/workflow-tracking/pages/workflow-runs-list-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/workflow-runs/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <WorkflowRunsListPage />
    </Suspense>
  ),
});
